import {axiosIns} from 'config/api.config'
import {ENV} from 'config/ENV.config'

/**
 * In-app notifications live in sso-service (`public.notifications`), shared by every ErpBoi
 * product and scoped per row by module_key. Call them through the SSO gateway — same
 * arrangement as Favorites (`favorite.service.ts`) — reusing axiosIns so the auth headers
 * and 401 interceptor still apply. The module is taken from the token's audience claim
 * server-side, so nothing here needs to send it.
 */
export const NotificationService = {
  /** Topbar bell feed — newest first, read and unread. */
  my: async (limit = 10): Promise<any> =>
    await axiosIns.get(`/notification/my?limit=${limit}`, {baseURL: ENV.ssoGetway}),

  unreadCount: async (): Promise<any> =>
    await axiosIns.get('/notification/unread-count', {baseURL: ENV.ssoGetway}),

  /** Paged list for the Notifications page. */
  getList: async (payload: any): Promise<any> =>
    await axiosIns.post('/notification/filter', payload, {baseURL: ENV.ssoGetway}),

  markRead: async (payload: {id: string}): Promise<any> =>
    await axiosIns.post('/notification/mark-read', payload, {baseURL: ENV.ssoGetway}),

  markAllRead: async (): Promise<any> =>
    await axiosIns.post('/notification/mark-all-read', {}, {baseURL: ENV.ssoGetway}),

  dismiss: async (payload: {id: string}): Promise<any> =>
    await axiosIns.delete('/notification/dismiss', {data: payload, baseURL: ENV.ssoGetway}),
}
